// --------------------------
// IMPORTS
// --------------------------
import { Link, useLocation } from "react-router-dom";
import TableContent from "../../components/atoms/TableContent";
import media from "../../media";
import { useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { decryptData } from "../../utils/Constants";
import { Button, message, Tooltip } from "antd";
import ExpenseListingDetail from "../ListOfExpense/expenseListingDetail";
import DraftExpenseRequest from "../ListOfExpense/draftExpenseRequest";
import APICaller from "../../utils/APICaller";
import ExportPdf from "../../utils/exportPdf";
import ReactDOMServer from "react-dom/server";
import html2pdf from "html2pdf.js";
import CustomLoader from "../../utils/CustomLoader";

// --------------------------
// MAIN COMPONENT
// --------------------------
export default function DashboardExpenseListing(props) {
  const {
    dashboardExpenseListingData,
    usersList,
    departmentsList,
    projectCodeList,
    expenseCodeList,
    currencyCodeList,
    onRefresh
  } = props;
  
  // --------------------------
  // REDUX STATE
  // --------------------------
  let storeRole = useSelector((state) => state.auth.role);
  let storeToken = useSelector((state) => state.auth.accessToken);
  let storeLIUId = useSelector((state) => state.auth.lIUId);
  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn
  );
  let storeUserInfo = useSelector((state) => state.auth.userInfo);
  storeUserInfo = decryptData(storeUserInfo);
  const storeEmpID = storeUserInfo?.user?.empID;

  const filteredfiltered = dashboardExpenseListingData.map((records) => {
    return {
      key: records?._id,
      empName: records?.empName,
      empID: records?.empID,
      businessPurpose: records?.businessPurpose,
      natureOfExpense: records?.natureOfExpense || "-",
      projectCodeID: records?.projectCodeID || "-",     
      departmentID:
        records?.expensesDetails && records?.expensesDetails.length === 1
          ? records.expensesDetails[records.expensesDetails.length - 1]
              ?.departmentID || null
          : "-",
      expenseCodeID:
        records?.expensesDetails && records?.expensesDetails.length === 1
          ? records.expensesDetails[records.expensesDetails.length - 1]
              ?.expenseCodeID || null
          : "-",
      currencyID:
        records?.expensesDetails && records?.expensesDetails.length === 1
          ? records.expensesDetails[records.expensesDetails.length - 1]
              ?.currencyID || null
          : "-",
      cost:
        records?.expensesDetails && records?.expensesDetails.length === 1
          ? records.expensesDetails[records.expensesDetails.length - 1]?.cost ||
            null
          : "-",
      totalReimbursement: records?.totalReimbursement,
      approvers: records?.approvers,
      adminApprover:
        records.status ===
          process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
        records?.adminApprover?.[0]?.status ===
          process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
        records?.adminApprover?.[0]?.reason
          ? process.env.REACT_APP_SENTBACK_STATUS
          : records?.adminApprover?.[0]?.status ===
            process.env.REACT_APP_APPROVED_STATUS.toUpperCase()
          ? process.env.REACT_APP_APPROVED_STATUS
          : records?.adminApprover?.[0]?.status ===
              process.env.REACT_APP_CANCELED_STATUS.toUpperCase() &&
            records?.adminApprover?.[0]?.reason
          ? process.env.REACT_APP_CANCELED_STATUS
          : process.env.REACT_APP_PENDING_STATUS,
      expensePeriod:
        records?.expensePeriodFromDate && records?.expensePeriodToDate
          ? moment(records.expensePeriodFromDate).format("Do MMM, YYYY") +
            " - " +
            moment(records.expensePeriodToDate).format("Do MMM, YYYY")
          : "",
      month: records?.expensePeriodFromDate
        ? moment(records.expensePeriodFromDate).format("MMM")
        : "",
      expensePeriodFromDate: records?.expensePeriodFromDate
        ? moment(records.expensePeriodFromDate).format("DD-MM-YY")
        : "",
      onBehalfApprovers: records?.onBehalfApprovers || null,
      children:
                records?.expensesDetails && records?.expensesDetails.length > 1
                ? records.expensesDetails.map((item, index) => ({
                                                                  key: item._id || index,
                                                                  date: item?.date
                                                                    ? moment(item.date).format("DD-MM-YYYY")
                                                                    : "-",
                                                                  description: item?.description || "-",                                                                  
                                                                  departmentID: item?.departmentID || "-",
                                                                  expenseCodeID: item?.expenseCodeID || "-",
                                                                  currencyID: item?.currencyID || "-",
                                                                  cost: item?.cost || "-",
                                                                  
                                                                }))
                : null,
      paymentPaidOn: records?.paymentPaidOn || null,
      modeOfPayment: records?.modeOfPayment || null,

      status: records?.history?.[records.history.length - 1]?.status,
    };
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  
  
  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [isVisible, setIsVisible] = useState(false);
  const [selectedRecordKey, setSelectedRecordKey] = useState(null);
  const [actionViewSelected, setActionViewSelected] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [hasSelectedRows, setHasSelectedRows] = useState("");

  // --------------------------
  // TABLE COLUMNS
  // --------------------------
  const columns = [
    {
      title: "Sr. No.",
      render: (text, record, index) => index + 1,
      className: "all-nowrap-column",
    },
    {
      title: "Name",
      dataIndex: "empName",
      key: "empName",
      className: "all-nowrap-column",
      render: (text, record, index) => {
        return (
          <>
            <div>{text}</div>
            {record?.empID && <small>Emp. Id: {record.empID}</small>}
          </>
        );
      },
    },
    {
      title: "Nature of Expense",
      dataIndex: "natureOfExpense",
      className: "all-nowrap-column",
    },
    {
      title: "Vendor Name",
      dataIndex: "businessPurpose",
      className: "all-nowrap-column",
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return <span title={text}>{truncatedText}</span>;
      },
    },
    {
      title: "Project Code",
      dataIndex: "projectCodeID",
      className: "all-nowrap-column",
      render: (text, record, index) => {
        const projectCodeInfo = projectCodeList.find(
          (projectCodeItem) => projectCodeItem.value == text
        );

        if (typeof projectCodeInfo?.label !== "string") return null;
        const [code = "", companyName = ""] = (projectCodeInfo?.label && projectCodeInfo?.label?.split(" - ")) || [];

        return (
          <>
            <div>{code}</div>
            <small>{companyName}</small>
          </>
        );
      },
    },
    {
      title: "Expense Period",
      dataIndex: "expensePeriod",
      className: "all-nowrap-column",
      render: (text) => {
        if (typeof text !== "string") return null;
        const [fromText = "", toText = ""] = (text && text?.split(" - ")) || [];

        const [fromDayMonth = "", fromYear = ""] =
          (fromText && fromText?.split(", ")) || [];
        const [toDayMonth = "", toYear = ""] =
          (toText && toText?.split(", ")) || [];

        return (
          <div className="splitDates">
            <span>
              {fromDayMonth}
              <small>{fromYear}</small>
            </span>
            <span>-</span>
            <span>
              {toDayMonth}
              <small>{toYear}</small>
            </span>
          </div>
        );
      },
    },
    {
      title: "Expense Month",
      dataIndex: "month",
      className: "all-nowrap-column",
    },
    {
      title: "Department Code",
      dataIndex: "departmentID",
      className: "all-nowrap-column",
      render: (text) => {
        let deptId = "";
        let deptName = "";
        let deptCode = "";

        if (text && typeof text === "object") {
          /** CASE 1: departmentID is an object */
          deptId = text._id || "";
          deptName = typeof text.name === "string" ? text.name : "";
          deptCode = typeof text.code === "string" ? text.code : "";
        } else {
          /** CASE 2: departmentID is a string */
          deptId = text;
          const deptInfo = departmentsList.find((d) => d.value == text);

          if (deptInfo?.label) {
            const [name = "", code = ""] = deptInfo.label.split(" - ");
            deptName = name;
            deptCode = code;
          }
        }

        return (
          <>
            <div>{deptName || "-"}</div>
            <small>{deptCode || ""}</small>
          </>
        );
      },
    },
    {
      title: "Expense Code",
      dataIndex: "expenseCodeID",
      className: "all-nowrap-column",
      render: (text) => {
        const expCodeInfo = expenseCodeList.find(
          (expCodeItem) => expCodeItem.value == text
        );

        if (typeof expCodeInfo?.label !== "string") return null;
        const [code = "", name = ""] =
          (expCodeInfo?.label && expCodeInfo?.label?.split(" - ")) || [];

        return (
          <>
            <div>{code}</div>
            <small>{name}</small>
          </>
        );
      },
    },
    {
      title: "Currency",
      dataIndex: "currencyID",
      className: "all-nowrap-column",
      render: (text, record) => {
        const currencyInfo = currencyCodeList.find(
          (currItem) => currItem.id === text
        );

        if (typeof currencyInfo?.code !== "string") return null;

        return currencyInfo?.code;
      },
    },
    {
      title: "Amount",
      dataIndex: "cost",
      className: "all-nowrap-column",
      render: (text, record) => {
        const currencyInfo = currencyCodeList.find(
          (currItem) => currItem.id === record?.currencyID
        );        
        return (
          text && (
            <span className="table-btn cursor-unset text-capitalize amount-btn">
              <span>
                {currencyInfo?.symbol_native &&
                  currencyInfo?.symbol_native}
                {text}
              </span>
            </span>
          )
        );
      },
    },
    {
      title: "Total Amount",
      dataIndex: "totalReimbursement",
      className: "all-nowrap-column",
      render: (text) =>
        text && (
          <span className={`table-btn cursor-unset text-capitalize amount-btn`}>
            <img src={media.documentNormal.svg} alt="Rupee" />
            <span>{text}</span>
          </span>
        ),
    },
    {
      title: "Approvers",
      dataIndex: "approvers",
      render: (approvers) => {        
        return (
          <div className="d-flex justify-content-start">            
            {approvers &&
              approvers.map((approver, index) => {
                
                const approverInfo = usersList.find((userItem) => userItem.id === approver?.userID);
                
                return (
                    <Tooltip
                      key={index}
                      title={`${approverInfo?.empName.toUpperCase()}, ${
                        approver?.status ? approver?.status : "NOT SENT"
                      }`}
                      className={`approvers-status-tooltip mr-5`}
                    >
                      <span>
                        {approverInfo?.profilePicUrl ? (
                          <>
                            <img
                              src={
                                process.env.REACT_APP_BACKEND +
                                "/images/" +
                                approverInfo?.profilePicUrl
                              }
                              alt="card icon"
                            />
                          </>
                        ) : (
                          <span className="initialLetter">
                            {approverInfo?.empName
                              ? approverInfo?.empName.charAt(0).toUpperCase()
                              : "?"}
                          </span>
                        )}
                        <b
                          className={`approvers-tooltips ${
                            approver?.status
                              ? approver?.status?.toLowerCase()
                              : "yetToSent"
                          }-tooltips`}
                        ></b>
                      </span>
                    </Tooltip>
                  )
                }
              )}
          </div>
        )
      },
    },
    {
      title: "Admin Action",
      dataIndex: "adminApprover",
      className: "all-nowrap-column",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      className: "all-nowrap-column",
      render: (text) => (
        <span
          className={`table-btn cursor-unset text-capitalize ${text?.toLowerCase()}-btn`}
        >
          {text?.toLowerCase() ===
          process.env.REACT_APP_SEEK_ACK_STATUS.replace(" ", "")?.toLowerCase()
            ? process.env.REACT_APP_SEEK_ACK_STATUS
            : text?.toLowerCase() ===
              process.env.REACT_APP_ACK_REC_STATUS.replace(
                " ",
                ""
              )?.toLowerCase()
            ? process.env.REACT_APP_ACK_REC_STATUS
            : text?.toLowerCase() ===
              process.env.REACT_APP_NORESPONSE_STATUS.replace(
                " ",
                ""
              )?.toLowerCase()
            ? process.env.REACT_APP_NORESPONSE_STATUS
            : text?.toLowerCase()}
        </span>
      ),
    },
    {
      title: "Payment Paid On",
      dataIndex: "paymentPaidOn",
      className: "all-nowrap-column",
      key: "paymentPaidOn",
      render: (date, record) => {
        if (!moment(date).isValid()) return "-";

        return (
          <>
            {moment(date).format("Do MMM, YYYY")}
            {record?.modeOfPayment && (
              <>
                <small>
                  <strong>(Mode of Payment: </strong> {record?.modeOfPayment})
                </small>
              </>
            )}
          </>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => {
        const draft =
          
          record.status === process.env.REACT_APP_DRAFT_STATUS.toUpperCase() &&
          record.empID === storeEmpID
            ? 1
            : 0;
        const link =
          draft === 1
            ? `/${process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN}/draft/${record?.key}`
            : `/${process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN}/${record?.key}`;
        const viewTitle = draft === 1 ? "View Draft" : "View";
        
        return (
          <> 
            <div className="table-menu-container">
              <div className="table-menu-icon text-grey-custom">⋯</div>
              <div className="table-dropdown-menu">
                <div className="table-menu-item">
                  <div
                    className="text-grey-custom text-size-12 viwLink cursor-pointer"
                    title={`${viewTitle}`}
                    onClick={() => handleView(record?.key, viewTitle)}
                  >
                    <i className="flaticon-eye icon-lg text-grey-custom"></i>{" "}
                    {`${viewTitle}`}
                  </div>
                </div>

                <div
                  className="table-menu-item"
                  onClick={() => handlePdfExport(record)}
                >
                  <i
                    className="fas fa-file-pdf icon-lg text-grey-custom cursor-pointer"
                    title="Download PDF"
                  ></i>{" "}
                  <span className="text-grey-custom">Download PDF</span>
                </div>
                {draft === 1 && (
                  <div className="table-menu-item">
                    <div
                      title="Publish" 
                      onClick={() => {
                        handleDraftExpenseForPublish(record?.key);
                      }}
                    >
                      <i
                        className="fas fa-paper-plane icon-lg text-grey-custom cursor-pointer"
                        aria-hidden="true"
                      ></i>{" "}
                      <span className="text-grey-custom">Publish</span>
                    </div>                    
                  </div>
                )}
              </div>
            </div>
          </>
        );
      },
    },
  ];

  // --------------------------
  // HANDLERS
  // --------------------------
  const handleView = (key, viewTitle) => {    
    setSelectedRecordKey(key);
    setIsVisible(true);
    setActionViewSelected(viewTitle);
  };

  const generatePdfContent = (
      record,
      expenseDetail,
      storeRole,
      storeToken,
      storeAccessTokenExpiresOn
    ) => {
      return ReactDOMServer.renderToString(
        <ExportPdf
          record={record}
          expenseDetail={expenseDetail}
          storeRole={storeRole}
          storeToken={storeToken}
          storeAccessTokenExpiresOn={storeAccessTokenExpiresOn}
        />
      );
    };

  const handlePdfExport = async (record) => {
      try {
        // Fetch expense details
        const endpoint = `/list-of-expense/${record?.key}`;
        const method = "GET";
        const payload = {};
        const response = await APICaller(
          storeRole,
          storeToken,
          endpoint,
          method,
          payload,
          storeAccessTokenExpiresOn
        );
  
        //setExpenseDetail(response);
  
        if (response) {
          // Step 1: Generate HTML content as a string
          const htmlContent = generatePdfContent(
            record,
            response,
            storeRole,
            storeToken,
            storeAccessTokenExpiresOn
          );
  
          // Define PDF options
          const options = {
            margin: [10, 10, 10, 10],
            filename: `${record.key}_Details.pdf`,
            html2canvas: {
              scale: 2, // Increase scale for better resolution
              useCORS: true,
              logging: true,
            },
            jsPDF: {
              unit: "mm",
              format: "a4",
              orientation: "portrait",
            },
          };
  
          // Generate PDF
          html2pdf()
            .from(htmlContent)
            .set(options)
            .save()
            .catch((error) => {
              console.error("Error generating PDF:", error);
            });
        }
      } catch (error) {
        console.error("Error fetching data or generating PDF:", error);
      }
    };

  const handleDraftExpenseForPublish = (id) => {
    
    setShowLoader(true);
    const endpoint = `/publishMulExpense`;
    const method = "PUT";
    const payload = {
      action: "publishMul",
      ids: [id],
      historySource: "listing-page-publish-button",
      historyUserID: storeLIUId,
      historyAction: "Publishing drafted expense",
      status: process.env.REACT_APP_PENDING_STATUS.toUpperCase(),
    };

    const messageKey = "publishDraftExpenseError";    
    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        setShowLoader(false);
        
        if (response.statusCode) {
          if (response.message) {
            message.open({
              key: messageKey,
              type: response.statusCode === 400 ? "error" : "success",
              duration: 0, // stay until closed
              content: (
                <div className="customMsgPopup">
                  <span>{response.message}</span>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => message.destroy(messageKey)}
                  >
                    X
                  </Button>
                </div>
              ),
            });
          } else {
            setHasSelectedRows("");
            message.destroy("publishDraftExpenseError");
            message.success("Expense published successfully.");
          }
          onRefresh();          
        }
      })
      .catch((error) => {
        
        setShowLoader(false);
        message.error("Something went wrong!");
      });
  };

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <>
      <CustomLoader showLoader={showLoader} />
      <div className="d-flex justify-content-between mb-5">
        <h3 className="card-label font-weight-bolder text-dark mb-1 text-size-14">
          Expense Listing
        </h3>
        <Link
          to="/list-of-expense"
          className="font-size-md font-size-sm seeAll"
        >
          See All
        </Link>
      </div>
      <div
        className="table-responsive list-of-expense-table"
        id="alltable-size"
      >
        <TableContent
          storeList={filteredfiltered}
          columns={columns}
          bordered={false}
          className=""
          pagination={false}
        />
      </div>
      {isVisible &&
        actionViewSelected === "View" &&
         (
          <ExpenseListingDetail
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            recordKey={selectedRecordKey}
          />
        )}
      {isVisible &&
        actionViewSelected === "View Draft" &&
         (
          <DraftExpenseRequest
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            recordKey={selectedRecordKey}
          />
        )}
    </>
  );
}
